import axios from "axios";
import React, { useEffect, useState } from "react";
import "./MchatViewer.css";
import CircularLoading from "../loading/Loading";
import { useNavigate } from "react-router-dom";

const MchatView = ({ id, docId }) => {
  const ANSWERSTATE = {
    q1: "",
    q2: "",
    q3: "",
    q4: "",
    q5: "",
    q6: "",
    q7: "",
    q8: "",
    q9: "",
    q10: "",
    q11: "",
    q12: "",
    q13: "",
    q14: "",
    q15: "",
    q16: "",
    q17: "",
    q18: "",
    q19: "",
    q20: "",
  };

  const [answers, setAnswers] = useState(ANSWERSTATE);
  const [mchatScore, setMchatScore] = useState(null);
  const [mchatStatus, setMchatStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("s2stoken");
  const navigate = useNavigate()

  useEffect(() => {
    const fetchMchat = async () => {
      const url = `${process.env.REACT_APP_BACKEND_URL}/api/get_mchat`;
      setLoading(true);
      try {
        const res = await axios.get(url, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            id: id,
            docId: docId,
          },
        });

        console.log("The API Response is : ", res.data.mchat);

        const ans = res.data.mchat;
        setMchatScore(ans?.mchat_score);
        setMchatStatus(ans?.mchat_status);

        setAnswers({
          q0: ans.q0,
          q1: ans.q1,
          q2: ans.q2,
          q3: ans.q3,
          q4: ans.q4,
          q5: ans.q5,
          q6: ans.q6,
          q7: ans.q7,
          q8: ans.q8,
          q9: ans.q9,
          q10: ans.q10,
          q11: ans.q11,
          q12: ans.q12,
          q13: ans.q13,
          q14: ans.q14,
          q15: ans.q15,
          q16: ans.q16,
          q17: ans.q17,
          q18: ans.q18,
          q19: ans.q19,
          q20: ans.q20,
        });
      } catch (error) {
        console.log("Error fetching MCHAT data", error);
        if (error?.response?.data?.message === 'Token has expired') {
          localStorage.removeItem('s2stoken')
          navigate('/')
        }
      } finally {
        setLoading(false);
      }
    };

    fetchMchat();
  }, []);

  const questions = [
    {
      id: 1,
      question:
        "If you point at something across the room, does your child look at it?",
      example:
        "if you point at a toy or an animal, does your child look at the toy or animal?",
    },
    {
      id: 2,
      question: "Have you ever wondered if your child might be deaf?",
      example: "",
    },
    {
      id: 3,
      question: "Does your child play pretend or make-believe?",
      example:
        "pretend to drink from an empty cup, pretend to talk on a phone, or pretend to feed a doll or stuffed animal?",
    },
    {
      id: 4,
      question: "Does your child like climbing on things?",
      example: "furniture, playground equipment, or stairs",
    },
    {
      id: 5,
      question:
        "Does your child make unusual finger movements near his or her eyes?",
      example:
        "does your child wiggle his or her fingers close to his or her eyes?",
    },
    {
      id: 6,
      question:
        "Does your child point with one finger to ask for something or to get help?",
      example: "pointing to a snack or toy that is out of reach",
    },
    {
      id: 7,
      question:
        "Does your child point with one finger to show you something interesting?",
      example: "pointing to an airplane in the sky or a big truck in the road",
    },
    {
      id: 8,
      question: "Is your child interested in other children?",
      example:
        "does your child watch other children, smile at them, or go to them?",
    },
    {
      id: 9,
      question:
        "Does your child show you things by bringing them to you or holding them up for you to see — not to get help, but just to share?",
      example: "showing you a flower, a stuffed animal, or a toy truck",
    },
    {
      id: 10,
      question: "Does your child respond when you call his or her name?",
      example:
        "does he or she look up, talk or babble, or stop what he or she is doing when you call his or her name?",
    },
    {
      id: 11,
      question:
        "When you smile at your child, does he or she smile back at you?",
      example: "",
    },
    {
      id: 12,
      question: "Does your child get upset by everyday noises?",
      example:
        "does your child scream or cry to noise such as a vacuum cleaner or loud music?",
    },
    {
      id: 13,
      question: "Does your child walk?",
      example: "",
    },
    {
      id: 14,
      question:
        "Does your child look you in the eye when you are talking to him or her, playing with him or her, or dressing him or her?",
      example: "",
    },
    {
      id: 15,
      question: "Does your child try to copy what you do?",
      example: "wave bye-bye, clap, or make a funny noise when you do",
    },
    {
      id: 16,
      question:
        "If you turn your head to look at something, does your child look around to see what you are looking at?",
      example: "",
    },
    {
      id: 17,
      question: "Does your child try to get you to watch him or her?",
      example:
        "does your child look at you for praise, or say “look” or “watch me”?",
    },
    {
      id: 18,
      question:
        "Does your child understand when you tell him or her to do something?",
      example: `if you don't point, can your child understand “put the book on the chair” or “bring me the blanket”?`,
    },
    {
      id: 19,
      question:
        "If something new happens, does your child look at your face to see how you feel about it?",
      example:
        "if he or she hears a strange or funny noise, or sees a new toy, will he or she look at your face?",
    },
    {
      id: 20,
      question: "Does your child like movement activities?",
      example: "being swung or bounced on your knee",
    },
  ];
  console.log(mchatScore);
  if (loading) {
    return <CircularLoading />;
  }
  // Moderate Risk
  // High Risk
  return answers ? (
    <div className="mchat-container">
      <p className="mchat-heading">MCHAT</p>
      <div className="mchat-status-container">
        {mchatScore !== null &&
        mchatScore !== "" &&
        mchatScore !== undefined ? (
          <>
            <p>MCHAT score - {mchatScore}</p>
            <p>
              MCHAT status -
              {mchatStatus === "Low Risk"
                ? mchatStatus
                : mchatStatus === "Moderate Risk"
                ? `${mchatStatus} (Please get M-CHAT tested after 6 months)`
                : `${mchatStatus} (Please consult an Early Development Specialist)`}
            </p>
          </>
        ) : (
          <p>MCHAT score and status is not available</p>
        )}
      </div>
      <table>
        <thead>
          <tr>
            <th>Question</th>
            <th>Answer</th>
          </tr>
        </thead>
        <tbody>
          {questions.map((q, index) => (
            <tr key={q.id}>
              <td>
                <strong>
                  Q{q.id} {". "}
                </strong>
                <strong>{q.question}</strong>
                {q.example && (
                  <p className="example">
                    Example: &nbsp;
                    <em>{q.example}</em>
                  </p>
                )}
              </td>
              <td>{answers[`q${q.id}`]}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  ) : (
    <div>MCHAT is not avelable yet </div>
  );
};

export default MchatView;
